import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  deleteButton: {
    color: theme.palette.error.main,
  },
  warningText: {
    color: theme.palette.warning.dark,
    marginTop: theme.spacing(2),
    fontSize: '0.85rem',
  },
}));

interface DeleteConfirmDialogProps {
  open: boolean;
  title: string;
  content: React.ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
  confirmButtonText?: string;
  cancelButtonText?: string;
  executing?: boolean;
}

const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  open,
  title,
  content,
  onCancel,
  onConfirm,
  confirmButtonText = '削除',
  cancelButtonText = 'キャンセル',
  executing = false,
}) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby="delete-confirm-dialog-title">
      <DialogTitle id="delete-confirm-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText component="div">{content}</DialogContentText>
        <DialogContentText className={classes.warningText}>※ 削除したレコードは復元できません</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={executing}>
          {cancelButtonText}
        </Button>
        <Button onClick={onConfirm} className={classes.deleteButton} disabled={executing}>
          {executing ? '処理中...' : confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
